<template>
  <!-- Work -->
  <div
    id="carakerja"
    class="rows"
  >
    <Video-Youtube />
    <p class="title-section">
      Bagaimana Zonasea Bekerja ?
    </p>
    <div>
      <div class="row work">
        <div class="tab">
          <button
            id="defaultOpen"
            class="tablinks"
            @click="openCity($event, 'ac1')"
          >
            <span class="tab-number">01</span>
            <p class="tab-text">
              Upload dokumentasi spesifikasi kapal anda segera
            </p>
          </button>
          <button
            class="tablinks"
            @click="openCity($event, 'ac2')"
          >
            <span class="tab-number">02</span>
            <p class="tab-text">
              Masukan lokasi dan waktu pembukaan posisi kapal anda
            </p>
          </button>
          <button
            class="tablinks"
            @click="openCity($event, 'ac3')"
          >
            <span class="tab-number">03</span>
            <p class="tab-text mt-2">
              Pilih rute ekspedisi
            </p>
          </button>
          <button
            class="tablinks"
            @click="openCity($event, 'ac4')"
          >
            <span class="tab-number">04</span>
            <p class="tab-text">
              Lakukan perjalanan dengan jadwal yang ada
            </p>
          </button>
        </div>

        <div
          id="ac1"
          class="tabcontent"
        >
          <img
            src="/images/1.png"
            class="img-work"
          >
        </div>
        <div
          id="ac2"
          class="tabcontent"
        >
          <img
            src="/images/2.png"
            class="img-work"
          >
        </div>
        <div
          id="ac3"
          class="tabcontent"
        >
          <img
            src="/images/3.png"
            class="img-work"
          >
        </div>
        <div
          id="ac4"
          class="tabcontent"
        >
          <img
            src="/images/4.png"
            class="img-work"
          >
        </div>
      </div>
    </div>
    
    <div
      id="accordionExample"
      class="accordion"
    >
      <div class="card">
        <div
          id="headingOne"
          class="card-header"
        >
          <button
            class="btn  btn-block text-center"
            type="button"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Upload dokumentasi spesifikasi kapal anda segera
          </button>
        </div>

        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordionExample"
        >
          <div class="card-body text-center">
            <img
              src="/images/1.png"
              class="img-work"
            >
          </div>
        </div>
      </div>
      <div class="card">
        <div
          id="headingTwo"
          class="card-header"
        >
          <button
            class="btn  btn-block text-center collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Masukan lokasi dan waktu pembukaan posisi kapal anda.
          </button>
        </div>
        <div
          id="collapseTwo"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordionExample"
        >
          <div class="card-body text-center">
            <img
              src="/images/2.png"
              class="img-work"
            >
          </div>
        </div>
      </div>
      <div class="card">
        <div
          id="headingThree"
          class="card-header"
        >
          <button
            class="btn btn-block text-center collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            Lakukan perjalanan dengan jadwal anda
          </button>
        </div>
        <div
          id="collapseFour"
          class="collapse"
          aria-labelledby="headingFour"
          data-parent="#accordionExample"
        >
          <div class="card-body text-center">
            <img
              src="/images/3.png"
              class="img-work"
            >
          </div>
        </div>
      </div>
      <div class="card">
        <div
          id="headingThree"
          class="card-header"
        >
          <button
            class="btn btn-block text-center collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            Pilih rute ekpsedisi
          </button>
        </div>
        <div
          id="collapseThree"
          class="collapse"
          aria-labelledby="headingThree"
          data-parent="#accordionExample"
        >
          <div class="card-body text-center">
            <img
              src="/images/4.png"
              class="img-work"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Work -->
</template>
<script>
import VideoYoutube from "./Video"
export default {
  name: "Work",
  components: {
    VideoYoutube,
  },
  data() {
    return {};
  },
  mounted() {
    document.getElementById("defaultOpen").click();
  },
  methods: {
    openCity: function(evt, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    },

    activAccordion(){
       
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
